import "./App.css";
import SortingVisualizer from "./Components/SortingVisualizer.jsx";
function App() {
  return (
    <div className="App">
      <SortingVisualizer></SortingVisualizer>
    </div>
  );
}

export default App;
